<template>
<!-- 	<div id="progress-ring">
	  <svg class="progress-ring" viewBox="-50,-50,100,100">
	    <circle class="progress-ring-circle" r="46"/>
	    <path class="progress-ring-ring" :d="path"/>
	  </svg>
	</div> -->

    <div class="progress blue">
        <span class="progress-left">
            <span class="progress-bar"></span>
        </span>
        <span class="progress-right">
            <span class="progress-bar"></span>
        </span>
        <div class="progress-value">90%</div>
    </div>

</template>

<script>
  export default {
    name: "progress-ring",
	props: {
	    value: {
	      type: Number,
	      default: 0,
	    },
	    min: {
	      type: Number,
	      default: 0,
	    },
	    max: {
	      type: Number,
	      default: 1,
	    },
	},
	computed: {
	    theta() {
	      const frac = (this.value - this.min) / (this.max - this.min) || 0;
	      return frac * 2 * Math.PI;
	    },
	    path() {
	      const large = this.theta > Math.PI;
	      return `M0,-46 A46,46,0,${large ? 1 : 0},1,${this.endX},${this.endY}`;
	    },
	    endX() {
	      return Math.cos(this.theta - Math.PI * 0.5) * 46;
	    },
	    endY() {
	      return Math.sin(this.theta - Math.PI * 0.5) * 46;
	    },
	}
  };
</script>

<style type="text/css">
.progress{
    width: 150px;
    height: 150px;
    line-height: 150px;
    background: none;
    margin: 0 auto;
    box-shadow: none;
    position: relative;
}
.progress:after{
    content: "";
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 2px solid #fff;
    position: absolute;
    top: 0;
    left: 0;
}
.progress > span{
    width: 50%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    top: 0;
    z-index: 1;
}
.progress .progress-left{
    left: 0;
}
.progress .progress-bar{
    width: 100%;
    height: 100%;
    background: none;
    border-width: 2px;
    border-style: solid;
    position: absolute;
    top: 0;
}
.progress .progress-left .progress-bar{
    left: 100%;
    border-top-right-radius: 80px;
    border-bottom-right-radius: 80px;
    border-left: 0;
    -webkit-transform-origin: center left;
    transform-origin: center left;
}
.progress .progress-right{
    right: 0;
}
.progress .progress-right .progress-bar{
    left: -100%;
    border-top-left-radius: 80px;
    border-bottom-left-radius: 80px;
    border-right: 0;
    -webkit-transform-origin: center right;
    transform-origin: center right;
    animation: loading-1 1.8s linear forwards;
}
.progress .progress-value{
    width: 85%;
    height: 85%;
    border-radius: 50%;
    border: 2px solid #ebebeb;
    font-size: 32px;
    line-height: 125px;
    text-align: center;
    position: absolute;
    top: 7.5%;
    left: 7.5%;
}
.progress.blue .progress-bar{
    border-color: #049dff;
}
.progress.blue .progress-value{
    color: #049dff;
}
.progress.blue .progress-left .progress-bar{
    animation: loading-2 1.5s linear forwards 1.8s;
}
.progress.yellow .progress-bar{
    border-color: #fdba04;
}
.progress.yellow .progress-value{
    color: #fdba04;
}
.progress.yellow .progress-left .progress-bar{
    animation: loading-3 1s linear forwards 1.8s;
}
.progress.pink .progress-bar{
    border-color: #ed687c;
}
.progress.pink .progress-value{
    color: #ed687c;
}
.progress.pink .progress-left .progress-bar{
    animation: loading-4 0.4s linear forwards 1.8s;
}
.progress.green .progress-bar{
    border-color: #1abc9c;
}
.progress.green .progress-value{
    color: #1abc9c;
}
.progress.green .progress-left .progress-bar{
    animation: loading-5 1.2s linear forwards 1.8s;
}
@keyframes loading-1{
    0%{
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100%{
        -webkit-transform: rotate(180deg);
        transform: rotate(180deg);
    }
}
@keyframes loading-2{
    0%{
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100%{
        -webkit-transform: rotate(144deg);
        transform: rotate(144deg);
    }
}
@keyframes loading-3{
    0%{
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100%{
        -webkit-transform: rotate(90deg);
        transform: rotate(90deg);
    }
}
@keyframes loading-4{
    0%{
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100%{
        -webkit-transform: rotate(36deg);
        transform: rotate(36deg);
    }
}
@keyframes loading-5{
    0%{
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100%{
        -webkit-transform: rotate(126deg);
        transform: rotate(126deg);
    }
}
@media only screen and (max-width: 990px){
    .progress{ margin-bottom: 20px; }
}




	.play-btn-wrap {
	    position: relative;
	}

	.progress-ring {
	    width: 65px;
	    height: 65px;
	    position: absolute;
	    left: 56px;
	    top: -2px;
	}

	.progress-ring-circle {
	  stroke: rgba(0, 0, 0, 0.1);
	  stroke-width: 1;
	  fill: none;
	}

	.progress-ring-ring {
	  stroke: #fff;
	  stroke-width: 3;
	  fill: none;
	}

</style>
